import PropTypes from 'prop-types';

import AppDownloadCtaCard from './AppDownloadCtaCard';
import StoreOffersCtaCard from './StoreOffersCtaCard';
import WhatsappGroupCtaCard from './WhatsappGroupCtaCard';
import WishlistCtaCard from './WishlistCtaCard';

const CtaCard = ({ type, storeId, storeImage, storeName, storeSlug }) => {
  switch (type) {
    case 'wishlist':
      return (
        <WishlistCtaCard
          storeId={storeId}
          storeImage={storeImage}
          storeName={storeName}
        />
      );
    case 'app-download':
      return <AppDownloadCtaCard />;
    case 'store-offers':
      return <StoreOffersCtaCard storeName={storeName} storeSlug={storeSlug} />;
    case 'whatsapp-group':
      return <WhatsappGroupCtaCard />;
    default:
      return null;
  }
};

CtaCard.propTypes = {
  storeId: PropTypes.number,
  storeImage: PropTypes.string,
  storeName: PropTypes.string.isRequired,
  storeSlug: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'wishlist',
    'app-download',
    'store-offers',
    'whatsapp-group',
  ]).isRequired,
};

export default CtaCard;
